import { jsPDF } from 'jspdf';
import logoImage from '../loggo.png';

/* ── brand colours ── */
const P  = [133, 78,  214];   // #c6acecff primary
const PL = [240, 233, 251];   // primary-pale
const DK = [  2,   1,   1];   // #020101 dark
const MT = [107,  95, 128];   // muted text
const WH = [255, 255, 255];   // white
const LN = [228, 218, 245];   // border/line colour
const GN = [  5, 150, 105];   // green accent

/* ── tiny helpers ── */
const fc  = (doc, c) => doc.setFillColor(...c);
const tc  = (doc, c) => doc.setTextColor(...c);
const dc  = (doc, c) => doc.setDrawColor(...c);
const box = (doc, x, y, w, h, c, r = 0) => { fc(doc, c); doc.roundedRect(x, y, w, h, r, r, 'F'); };

function hline(doc, y) {
  dc(doc, LN); doc.setLineWidth(0.25); doc.line(15, y, 195, y);
}

function pageFooter(doc, n, tot) {
  tc(doc, MT); doc.setFontSize(7.5); doc.setFont('helvetica', 'normal');
  doc.text('KI INNOVATION — Airport Baggage Systems Guide', 15, 289);
  doc.text(`${n} / ${tot}`, 195, 289, { align: 'right' });
}

function secHead(doc, text, y) {
  box(doc, 15, y, 180, 9, PL, 2);
  tc(doc, P); doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
  doc.text(text, 20, y + 6.5);
  return y + 15;
}

function para(doc, text, y, maxW = 165) {
  tc(doc, DK); doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5);
  const lines = doc.splitTextToSize(text, maxW);
  doc.text(lines, 20, y);
  return y + lines.length * 5.5 + 3;
}

function bullet(doc, text, y, maxW = 158) {
  box(doc, 20, y + 1.5, 3, 3, P, 1.5);
  tc(doc, DK); doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
  const lines = doc.splitTextToSize(text, maxW);
  doc.text(lines, 27, y + 5);
  return y + lines.length * 5 + 4;
}

/* ════════════════════════════════
   COVER
════════════════════════════════ */
function cover(doc) {
  // full purple background
  box(doc, 0, 0, 210, 297, P);

  // decorative accent - top right corner
  box(doc, 150, 0, 60, 60, [110, 50, 190]);

  // white diagonal strip (bottom third) with curve effect
  fc(doc, WH);
  doc.setFillColor(255, 255, 255);
  box(doc, 0, 200, 210, 97, WH);

  // purple accent line above white section
  box(doc, 0, 195, 210, 5, [110, 50, 190]);

  // logo image
  doc.addImage(logoImage, 'PNG', 15, 15, 50, 20);

  // free badge with gradient effect
  box(doc, 15, 42, 65, 10, [110, 50, 190], 3);
  tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
  doc.text('FREE PDF GUIDE  •  60 PAGES', 20, 49);

  // main headline
  tc(doc, WH); doc.setFont('helvetica', 'bold');
  doc.setFontSize(32); doc.text('The Complete', 15, 85);
  doc.setFontSize(32); doc.text('Airport Baggage', 15, 102);
  doc.setFontSize(32); doc.text('Systems Guide', 15, 119);

  // sub with better spacing
  tc(doc, [210, 185, 245]); doc.setFont('helvetica', 'normal'); doc.setFontSize(11);
  doc.text('Belt Architecture  ·  RFID & AI  ·  Safety', 15, 132);
  doc.text('Maintenance  ·  Future Trends', 15, 142);

  // decorative purple line
  box(doc, 15, 150, 80, 3, [110, 50, 190], 1.5);

  // stats on white band with better design
  [['60', 'Pages'], ['40+', 'Diagrams'], ['6', 'Chapters'], ['Free', 'No Cost']].forEach(([v, l], i) => {
    const x = 18 + i * 47;
    // purple border box
    dc(doc, P); doc.setLineWidth(0.5);
    doc.roundedRect(x, 215, 40, 22, 4, 4, 'S');
    // light purple background
    box(doc, x + 1, 216, 38, 20, PL, 3);
    tc(doc, P); doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
    doc.text(v, x + 20, 226, { align: 'center' });
    tc(doc, MT); doc.setFont('helvetica', 'normal'); doc.setFontSize(7);
    doc.text(l, x + 20, 233, { align: 'center' });
  });

  // footer with purple accent
  tc(doc, MT); doc.setFontSize(7);
  doc.text('© 2025 KI INNOVATION  |  info@kiinnovation.in  |  Educational use only', 105, 260, { align: 'center' });
  // purple line above footer
  box(doc, 70, 265, 70, 2, [110, 50, 190], 1);
}

/* ════════════════════════════════
   TABLE OF CONTENTS
════════════════════════════════ */
function toc(doc, pg, tot) {
  box(doc, 0, 0, 210, 28, P);
  // logo in header
  doc.addImage(logoImage, 'PNG', 15, 6, 20, 8);
  tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
  doc.text('Table of Contents', 40, 13);

  const entries = [
    ['01', 'System Architecture Overview',       '3'],
    ['02', 'RFID & Barcode Technology',           '5'],
    ['03', 'AI Sorting & Automation',             '7'],
    ['04', 'Safety Systems & Emergency Response', '9'],
    ['05', 'Maintenance & Predictive Analytics',  '11'],
    ['06', 'Future Trends & Innovations',         '13'],
  ];

  let y = 38;
  entries.forEach(([num, title, p], i) => {
    if (i % 2 === 0) box(doc, 15, y - 5, 180, 12, PL, 2);

    box(doc, 15, y - 4, 11, 10, P, 2);
    tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
    doc.text(num, 20.5, y + 2.8, { align: 'center' });

    tc(doc, DK); doc.setFont('helvetica', 'bold'); doc.setFontSize(9.5);
    doc.text(title, 30, y + 3);

    tc(doc, P); doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
    doc.text(`p. ${p}`, 187, y + 3, { align: 'right' });

    // dotted leader line
    dc(doc, LN); doc.setLineWidth(0.2);
    doc.setLineDashPattern([1, 2], 0);
    const lx = 32 + doc.getTextWidth(title) + 2;
    doc.line(lx, y + 1, 178, y + 1);
    doc.setLineDashPattern([], 0);

    y += 15;
  });

  pageFooter(doc, pg, tot);
}

/* ════════════════════════════════
   shared chapter header
════════════════════════════════ */
function chapHead(doc, num, title, sub) {
  box(doc, 0, 0, 210, 38, P);
  // small logo in header
  doc.addImage(logoImage, 'PNG', 15, 8, 20, 8);
  box(doc, 40, 9, 20, 20, [110, 50, 190], 4);
  tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
  doc.text(num, 50, 21, { align: 'center' });
  doc.setFontSize(14); doc.text(title, 65, 19);
  tc(doc, [210, 185, 245]); doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
  doc.text(sub, 65, 27);
}

/* ════════════════════════════════
   CH 1 — Architecture
════════════════════════════════ */
function ch1(doc, pg, tot) {
  chapHead(doc, '01', 'System Architecture Overview', '12 pages  ·  Zones, flow, components');
  let y = 48;
  y = para(doc, 'A modern airport baggage handling system (BHS) is one of the most complex automated logistics networks in the world. Operating 24/7, it must process thousands of bags per hour while maintaining near-perfect accuracy. Understanding its architecture is the foundation for everything in this guide.', y);
  y = secHead(doc, '1.1  The Five Core Zones', y);
  const zones = [
    ['Check-In Zone',       'Staffed counters and self-service kiosks where bags are tagged, weighed, and placed on the first inbound belt. Speed: 0.5–1.0 m/s for passenger safety.'],
    ['Primary Sortation',   'High-speed flat-belt and tilt-tray sorters direct bags to departure chutes at up to 10 m/s. Crossbelt sorters handle irregulars and fragile items.'],
    ['Security Screening',  'Automated inline screening (ILS) integrates explosive detection (EDS) into the belt flow. Levels: CT scan, automated analysis, manual resolution.'],
    ['Hold Sorting Area',   'Bags are accumulated per flight in vertical or horizontal make-up units. Ground staff load directly, often aided by automated loaders.'],
    ['Reclaim Carousel',    'From aircraft, bags travel via apron tug to feeder belt to the arrivals carousel — a continuous loop belt at ~0.4 m/s.'],
  ];
  zones.forEach(([t, d]) => {
    if (y > 255) { doc.addPage(); pageFooter(doc, ++pg, tot); y = 18; }
    box(doc, 18, y, 172, 24, PL, 3);
    tc(doc, P); doc.setFont('helvetica', 'bold'); doc.setFontSize(9);
    doc.text(t, 23, y + 7);
    tc(doc, MT); doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
    const ls = doc.splitTextToSize(d, 155);
    doc.text(ls, 23, y + 13);
    y += ls.length > 1 ? 30 : 26;
  });
  pageFooter(doc, pg, tot);
}

/* ════════════════════════════════
   CH 2 — RFID
════════════════════════════════ */
function ch2(doc, pg, tot) {
  chapHead(doc, '02', 'RFID & Barcode Technology', '10 pages  ·  Tracking, read rates, IATA 753');
  let y = 48;
  y = secHead(doc, '2.1  Two Technologies, One Goal', y);
  y = para(doc, 'Every bag in a modern airport carries a unique identifier — either a 10-digit IATA barcoded bag tag or an RFID-enabled smart tag. Both link the physical bag to a passenger record in the Baggage Management System (BMS) in real time.', y);
  y = secHead(doc, '2.2  Barcode vs RFID', y);

  // table header
  box(doc, 15, y, 180, 9, P, 2);
  tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5);
  ['Attribute', 'Barcode', 'RFID Tag'].forEach((h, i) => doc.text(h, [20, 80, 145][i], y + 6.5));
  y += 9;

  [
    ['Read accuracy',    '~85%',             '~99.9%'],
    ['Read range',       'Line-of-sight',    'Up to 5 metres'],
    ['Read speed',       '1 at a time',      '100+ at once'],
    ['Cost per tag',     '$0.01–0.03',       '$0.15–0.50'],
    ['IATA 753 support', 'Partial',          'Full'],
    ['Orientation',      'Must face scanner','Any angle'],
  ].forEach((row, ri) => {
    if (ri % 2 === 0) box(doc, 15, y, 180, 8, PL, 0);
    doc.setFontSize(8.5);
    tc(doc, DK); doc.setFont('helvetica', 'bold');   doc.text(row[0], 20,  y + 5.5);
    tc(doc, MT); doc.setFont('helvetica', 'normal'); doc.text(row[1], 80,  y + 5.5);
    tc(doc, [30, 130, 80]);                           doc.text(row[2], 145, y + 5.5);
    y += 8;
  });

  y += 5;
  y = secHead(doc, '2.3  IATA Resolution 753', y);
  [
    'Mandates bag tracking at 4 checkpoints: handover, loading, transfer, and return to passenger.',
    'Read rates must exceed 99% at each checkpoint for airline compliance.',
    'Airlines must share data via WorldTracer for mishandled bag resolution.',
    'RFID airports report 70–80% fewer mishandled bags vs barcode-only systems.',
  ].forEach(b => { y = bullet(doc, b, y); });

  pageFooter(doc, pg, tot);
}

/* ════════════════════════════════
   CH 3 — AI Sorting
════════════════════════════════ */
function ch3(doc, pg, tot) {
  chapHead(doc, '03', 'AI Sorting & Automation', '14 pages  ·  BMS, sorters, data flow');
  let y = 48;
  y = secHead(doc, '3.1  The Baggage Management System (BMS)', y);
  y = para(doc, 'The BMS is the brain of the entire operation. It receives check-in data from the Departure Control System (DCS), correlates it with bag-tag reads, and calculates the optimal path for every bag across thousands of divert points in real time.', y);
  y = secHead(doc, '3.2  Sorting Technologies', y);
  [
    ['Flat Belt Sorter',        'Low-cost, handles bags up to 50 kg at 2.5 m/s using pop-up diverters or pusher arms.'],
    ['Tilt-Tray Sorter',        'Each tray tilts 30° to divert into chutes. Throughput: 6,000–10,000 bags/hr. Most common in hubs.'],
    ['Crossbelt Sorter',        'Small conveyor on each carrier spins 90°. Handles irregular/fragile items gently at 4,000–8,000 bags/hr.'],
    ['Destination-Coded Vehicle','Autonomous carts, one bag each, navigate via track. Highest accuracy. Used at Dubai DXB and Singapore SIN.'],
  ].forEach(([t, d]) => {
    if (y > 255) { doc.addPage(); pageFooter(doc, ++pg, tot); y = 18; }
    box(doc, 18, y, 3, 14, P, 1.5);
    tc(doc, P); doc.setFont('helvetica', 'bold'); doc.setFontSize(9);
    doc.text(t, 25, y + 6);
    const ls = doc.splitTextToSize(d, 155);
    tc(doc, MT); doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
    doc.text(ls, 25, y + 12);
    y += ls.length > 1 ? 24 : 20;
  });
  y += 3;
  y = secHead(doc, '3.3  AI Decision Engine', y);
  [
    'Real-time flight slot optimisation — BMS adjusts routing dynamically when gates change.',
    'ML models trained on historical data predict peak loads and pre-allocate belt capacity.',
    'Anomaly detection flags bags with unusual weights or RFID read gaps within milliseconds.',
    'Self-healing routing: on belt failure, BMS instantly reroutes all affected bags via alternate paths.',
  ].forEach(b => { y = bullet(doc, b, y); });
  pageFooter(doc, pg, tot);
}

/* ════════════════════════════════
   CH 4 — Safety
════════════════════════════════ */
function ch4(doc, pg, tot) {
  chapHead(doc, '04', 'Safety Systems & Emergency Response', '8 pages  ·  E-stops, fire, redundancy');
  let y = 48;
  y = secHead(doc, '4.1  Emergency Stop Network', y);
  y = para(doc, 'Every belt section has manual E-stop pull cords at 2-metre intervals and automatic E-stops triggered by jam sensors, motor faults, or overtemperature alerts. A single E-stop cascades a controlled shutdown of all upstream feeders to prevent pile-up.', y);
  y = secHead(doc, '4.2  Six-Step Emergency Protocol', y);
  [
    ['1. Detect',   'Sensor or camera identifies blockage, fire, or intrusion.'],
    ['2. Alert',    'BMS generates alarm; control room receives visual + audio notification within 200 ms.'],
    ['3. Isolate',  'Affected belt segment stops; upstream belts ramp down in sequence.'],
    ['4. Dispatch', 'Nearest technician receives mobile alert with exact location.'],
    ['5. Resolve',  'Manual intervention clears jam or activates halon fire suppression.'],
    ['6. Resume',   'Section restarted after clearance; BMS logs full incident with timestamps.'],
  ].forEach(([s, d], i) => {
    if (y > 258) { doc.addPage(); pageFooter(doc, ++pg, tot); y = 18; }
    box(doc, 18, y, 18, 9, P, 2);
    tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
    doc.text(s, 27, y + 6, { align: 'center' });
    tc(doc, DK); doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
    const ls = doc.splitTextToSize(d, 148);
    doc.text(ls, 40, y + 6);
    y += ls.length > 1 ? 16 : 13;
  });
  y += 4;
  y = secHead(doc, '4.3  Redundancy Architecture', y);
  [
    'Dual-path routing: every critical belt section has a parallel bypass activated automatically on failure.',
    'UPS backup maintains belt operation for 30 minutes on full load during power outages.',
    'Redundant BMS servers (hot standby) with sub-second failover — no loss of bag tracking data.',
    'VESDA smoke detection integrated into belt tunnels triggers suppression in under 3 seconds.',
  ].forEach(b => { y = bullet(doc, b, y); });
  pageFooter(doc, pg, tot);
}

/* ════════════════════════════════
   CH 5 — Maintenance
════════════════════════════════ */
function ch5(doc, pg, tot) {
  chapHead(doc, '05', 'Maintenance & Predictive Analytics', '9 pages  ·  Schedules, IoT, case studies');
  let y = 48;
  y = secHead(doc, '5.1  Standard Maintenance Schedule', y);
  [
    ['Daily',    'Visual inspection of belt surfaces, splice condition, and roller alignment. Lubrication of high-speed bearings. Sensor calibration check.'],
    ['Weekly',   'Motor current-draw analysis, gearbox oil level, brake pad inspection, full RFID reader test cycle, E-stop pull-cord tests.'],
    ['Monthly',  'Full belt-tension audit, motor thermal imaging, conveyor speed verification against spec, BMS software patch review.'],
    ['Annually', 'Complete belt replacement on high-wear sections, gearbox overhaul, full wiring harness inspection, emergency drill exercise.'],
  ].forEach(([freq, tasks]) => {
    if (y > 252) { doc.addPage(); pageFooter(doc, ++pg, tot); y = 18; }
    box(doc, 18, y, 26, 9, P, 3);
    tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
    doc.text(freq, 31, y + 6.5, { align: 'center' });
    const ls = doc.splitTextToSize(tasks, 138);
    tc(doc, DK); doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
    doc.text(ls, 50, y + 6);
    y += ls.length > 1 ? 20 : 16;
  });
  y += 4;
  y = secHead(doc, '5.2  Predictive Analytics via IoT', y);
  [
    'Vibration sensors emit data at 10 Hz — anomaly patterns identified 2–4 weeks before failure.',
    'Temperature sensors in gearboxes alert at 5 °C above baseline, preventing 60% of thermal stoppages.',
    'Belt-stretch sensors measure elongation in real time; replacement triggered at 2% stretch.',
    'Heathrow T5 reported a 35% reduction in unplanned downtime after deploying IoT-driven maintenance.',
  ].forEach(b => { y = bullet(doc, b, y); });
  pageFooter(doc, pg, tot);
}

/* ════════════════════════════════
   CH 6 — Future Trends
════════════════════════════════ */
function ch6(doc, pg, tot) {
  chapHead(doc, '06', 'Future Trends & Innovations', '7 pages  ·  Robots, biometrics, sustainability');
  let y = 48;
  y = secHead(doc, '6.1  Autonomous Baggage Robots', y);
  y = para(doc, 'Self-driving AGVs are already operational at Amsterdam Schiphol and Singapore Changi. These Level 4 autonomous carts navigate via LiDAR and SLAM mapping, carrying individual bags from check-in directly to the aircraft hold without entering the traditional belt network.', y);
  y = secHead(doc, '6.2  Biometric-Linked Routing', y);
  [
    'Face-recognition at bag drop links biometric identity to the bag — no physical tag needed.',
    'BMS routes the bag by passenger biometric identity rather than tag ID.',
    'Pilot programmes at Dubai DXB and Doha HIA show 0.005% mishandled bag rates — 200× better than barcode.',
    'IATA One ID standardises biometric bag-to-passenger linking across 290+ airlines by 2027.',
  ].forEach(b => { y = bullet(doc, b, y); });
  y += 4;
  y = secHead(doc, '6.3  Sustainability', y);
  [
    'Regenerative drives recover kinetic energy on deceleration — cutting belt energy use by up to 30%.',
    'Recycled-rubber belt compounds from tyre feedstock are now certified for airport use.',
    'Solar-supplemented belt power at regional airports in Spain and Australia reduces grid use by 18%.',
    'Low-noise variable-frequency drives reduce operational noise by 12 dB near terminal belt sections.',
  ].forEach(b => { y = bullet(doc, b, y); });
  y += 4;
  y = secHead(doc, '6.4  Automation Roadmap', y);
  [
    ['2025', 'RFID mandatory at all IATA Cat-A airports under Resolution 753 enforcement.'],
    ['2027', 'AI-driven routing autonomous for 95%+ of bags; human exceptions only.'],
    ['2029', 'Biometric bag linkage replaces physical tags at top-20 hub airports.'],
    ['2032', 'Full end-to-end autonomous baggage journey — robot drop to robot load.'],
  ].forEach(([yr, ms]) => {
    if (y > 265) { doc.addPage(); pageFooter(doc, ++pg, tot); y = 18; }
    box(doc, 18, y, 18, 8, P, 3);
    tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
    doc.text(yr, 27, y + 5.7, { align: 'center' });
    tc(doc, DK); doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
    doc.text(ms, 41, y + 5.7);
    y += 13;
  });
  pageFooter(doc, pg, tot);
}

/* ════════════════════════════════
   BACK COVER
════════════════════════════════ */
function backCover(doc) {
  box(doc, 0, 0, 210, 297, P);
  box(doc, 0, 245, 210, 52, [110, 50, 190]);

  // logo at top
  doc.addImage(logoImage, 'PNG', 82, 15, 45, 18);

  tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(20);
  doc.text('Thank You for Reading', 105, 90, { align: 'center' });

  tc(doc, [210, 185, 245]); doc.setFont('helvetica', 'normal'); doc.setFontSize(10);
  doc.text('We hope this guide deepened your understanding of', 105, 104, { align: 'center' });
  doc.text('airport baggage conveyor systems.', 105, 112, { align: 'center' });

  // contact box
  box(doc, 35, 128, 140, 52, [110, 50, 190], 6);
  tc(doc, WH); doc.setFont('helvetica', 'bold'); doc.setFontSize(9);
  doc.text('CONTACT US', 105, 141, { align: 'center' });
  tc(doc, [210, 185, 245]); doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
  ['info@kiinnovation.in', '+91 92281 66525', 'Airport Technology Hub, Terminal 3']
    .forEach((c, i) => doc.text(c, 105, 152 + i * 9, { align: 'center' }));

  tc(doc, [170, 140, 210]); doc.setFontSize(7.5);
  doc.text('© 2025 KI INNOVATION  |  For educational purposes only  |  KI INNOVATION.tech', 105, 284, { align: 'center' });
}

/* ════════════════════════════════
   MAIN EXPORT
════════════════════════════════ */
export function generateBrochurePDF(userName = '') {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true });
  const TOT = 15;

  cover(doc);
  doc.addPage(); toc(doc, 2, TOT);
  doc.addPage(); ch1(doc, 3, TOT);
  doc.addPage(); ch2(doc, 5, TOT);
  doc.addPage(); ch3(doc, 7, TOT);
  doc.addPage(); ch4(doc, 9, TOT);
  doc.addPage(); ch5(doc, 11, TOT);
  doc.addPage(); ch6(doc, 13, TOT);
  doc.addPage(); backCover(doc);

  const name = userName ? userName.trim().replace(/\s+/g, '-') : '';
  doc.save(name ? `KI INNOVATION-Guide-${name}.pdf` : 'KI INNOVATION-Baggage-Systems-Guide.pdf');
}
